import i18n from './attribute-modification-key.properties';

/**
 * Attribute modification keys.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/model/AttributeModificationKey.java
 */
export const AttributeModificationKey = {
  NAME: 'NAME',
  FORMAT: 'FORMAT',
  VALUE_DISTRIBUTION: 'VALUE_DISTRIBUTION',
  LOCAL_HIERARCHY_LEVEL: 'LOCAL_HIERARCHY_LEVEL',
  USE_LOCAL_HIERARCHY_LEVEL: 'USE_LOCAL_HIERARCHY_LEVEL',
  USE_SCALE_DEPENDENT_HIERARCHY_LEVEL: 'USE_SCALE_DEPENDENT_HIERARCHY_LEVEL',
  MEASURE_AGGREGATION: 'MEASURE_AGGREGATION',
  TOTALS_AGGREGATION: 'TOTALS_AGGREGATION',
  NOMINAL_CLASSIFICATION_COLOR_PALETTE: 'NOMINAL_CLASSIFICATION_COLOR_PALETTE',
  POSTGIS_RASTER_PRECONFIGURED_MAPPING_ID: 'POSTGIS_RASTER_PRECONFIGURED_MAPPING_ID',
  POSTGIS_RASTER_VALUE_RANGE_MIN: 'POSTGIS_RASTER_VALUE_RANGE_MIN',
  POSTGIS_RASTER_VALUE_RANGE_MAX: 'POSTGIS_RASTER_VALUE_RANGE_MAX',
  SINGLE_COLOR: 'SINGLE_COLOR',
  TABLE_CELL_PRESENTATION: 'TABLE_CELL_PRESENTATION',
  SHOW_SUBTOTALS: 'SHOW_SUBTOTALS',
  TOP_N_ROWS_ENABLED: 'TOP_N_ROWS_ENABLED',
  TOP_N_SORT_ORDER: 'TOP_N_SORT_ORDER',
  TOP_N_ROWS_MAX_ROWS_PER_GROUP: 'TOP_N_ROWS_MAX_ROWS_PER_GROUP',
  TOP_N_MEASURE: 'TOP_N_MEASURE',
  TOP_N_ROWS_SHOW_COLLAPSED_OTHERS: 'TOP_N_ROWS_SHOW_COLLAPSED_OTHERS',
  TOP_N_OTHERS_LABEL: 'TOP_N_OTHERS_LABEL',
  SUBTOTAL_LABEL: 'SUBTOTAL_LABEL',
  NUMERICAL_CLASSIFICATION_GRADIENT: 'NUMERICAL_CLASSIFICATION_GRADIENT',
  NUMERICAL_CLASSIFICATION_GRADIENT_REVERSE: 'NUMERICAL_CLASSIFICATION_GRADIENT_REVERSE',
  SORT_HIERARCHY_LEVEL: 'SORT_HIERARCHY_LEVEL',
  SORT_ORDER: 'SORT_ORDER',
  REQUEST_ALL_DIMENSION: 'REQUEST_ALL_DIMENSION',
  COLUMNS_SIZE: 'COLUMNS_SIZE',
  VISIBLE: 'VISIBLE'
};

AttributeModificationKey.values = Object.values(AttributeModificationKey);
AttributeModificationKey.valuesAllowedOnClient = AttributeModificationKey.values
  .filter(key => {
    switch (key) {
      case AttributeModificationKey.SORT_HIERARCHY_LEVEL:
      case AttributeModificationKey.SORT_ORDER:
        return false;
      default:
        return true;
    }
  });
AttributeModificationKey.i18n = i18n;
